import { useTeam } from "@hooks";
import { useState } from "react";

import EditableNoteFormWrapper from "./EditableNoteFormWrapper";
import {
  AutosaveProvider,
  UploadProgressProvider,
  useApplyTemplate,
} from "../../../hooks";

export function EditableNote(props) {
  const {
    note,
    isSuperSOAP = false,
    isScribeEdit = false,
    shouldBillUserForNote,
    refetchNote,
    shouldShowTranscriptDrawer,
    setShouldShowTranscriptDrawer,
  } = props;
  let isQuicknote =
    props.isQuicknote ||
    (note?.quickNote !== null && note?.quickNote !== undefined);
  let patientUUID = props?.patientUUID || note?.patient?.uuid;

  const [shouldShowDeleteNoteModal, setShouldShowDeleteNoteModal] =
    useState(false);

  const { currentTeam } = useTeam();

  const noteUUID = note?.uuid;
  const teamUUID = note?.team?.uuid || currentTeam?.uuid;

  const { template } = useApplyTemplate({ noteUuid: noteUUID });

  return (
    <div>
      <UploadProgressProvider>
        <AutosaveProvider>
          <EditableNoteFormWrapper
            note={note}
            template={template}
            isScribeEdit={isScribeEdit}
            shouldBillUserForNote={shouldBillUserForNote}
            isSuperSOAP={isSuperSOAP}
            isQuicknote={isQuicknote}
            patientUUID={patientUUID}
            noteUUID={noteUUID}
            teamUUID={teamUUID}
            refetchNote={refetchNote}
            shouldShowDeleteNoteModal={shouldShowDeleteNoteModal}
            setShouldShowDeleteNoteModal={
              setShouldShowDeleteNoteModal
            }
            shouldShowTranscriptDrawer={shouldShowTranscriptDrawer}
            setShouldShowTranscriptDrawer={
              setShouldShowTranscriptDrawer
            }
          />
        </AutosaveProvider>
      </UploadProgressProvider>
    </div>
  );
}
